class ProjectManagerController {
  constructor(AppsService) {
    'ngInject';
    // load list of issues to show in the ui
    AppsService.projectManagerIssues().then((issues) => this.issues = issues);
  }
}

export default ProjectManagerController;



// WEBPACK FOOTER //
// ./client/app/components/apps/projectManager/projectManager.controller.js